<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Add lesson')"></breadcrumbs>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <card type="frame">
            <form-create-course-lesson></form-create-course-lesson>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from "../../../../Layout/Breadcrumbs.vue";
  import FormCreateCourseLesson from "../../../../Forms/Lesson/FormCreateLesson";

  export default {
    name: 'CourseLessonAdd',
    metaInfo() {
      return {
        title: `${this.lessonName} | ${this.$i18n.t('Add lesson')}`
      }
    },
    computed: {
      lessonName() {
        return this.$store.getters['course/lesson/getLessonTitle'] || ''
      }
    },
    components: {
      FormCreateCourseLesson,
      Breadcrumbs
    },
  };

</script>

<style scoped>

</style>
